import validate from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}